import withEntity from '@/entity/components/with-entity';

import IncompleteBanner from './incomplete-banner';

export default withEntity(IncompleteBanner);
